import { Controller } from "@hotwired/stimulus"

// The Location access editor: adds rows, and confirms a worldwide grant.
//
// The confirm sits at the SAVE step, not when the row is added, per the owner
// directive that confirmations belong at the action. It uses the app's native
// modal (window.appConfirm) and never confirm(): this form carries
// data-turbo="false", where turbo_confirm is dead, and browser dialogs are
// forbidden anyway.
export default class extends Controller {
  static targets = ["rows", "template"]

  connect() {
    this.confirmed = false
    this.form = this.element.closest("form")
    if (this.form) {
      this.onSubmit = this.submit.bind(this)
      this.form.addEventListener("submit", this.onSubmit)
    }
    // bfcache: a browser Back can restore this page with the latch still set,
    // which would skip the confirm on the next save.
    this.onPageShow = () => { this.confirmed = false }
    window.addEventListener("pageshow", this.onPageShow)
  }

  disconnect() {
    if (this.form) this.form.removeEventListener("submit", this.onSubmit)
    window.removeEventListener("pageshow", this.onPageShow)
  }

  add(event) {
    event.preventDefault()
    const html = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now())
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
  }

  async submit(event) {
    if (this.confirmed) return
    if (!this.#addingWorldwide()) return

    event.preventDefault()
    const ok = await window.appConfirm(
      "Grant worldwide location access? They will be able to use the app from any country.",
      { confirmLabel: "Grant worldwide", cancelLabel: "Cancel" }
    )
    if (!ok) return

    this.confirmed = true
    this.form.requestSubmit()
  }

  // Only a NEW worldwide row prompts. Re-saving the page of someone who
  // already has one should not nag.
  #addingWorldwide() {
    return Array.from(this.rowsTarget.querySelectorAll("[data-location-grant-row-target='type']"))
      .some((select) => {
        const row = select.closest("[data-controller='location-grant-row']")
        const persisted = row?.querySelector("input[name*='[id]']")?.value
        const destroyed = row?.querySelector("input[name*='[_destroy]']")?.value === "1"
        return select.value === "worldwide" && !persisted && !destroyed
      })
  }
}
